import {
  CHECKBOX,
  PAYMENT_STATUS_ITEMS,
  CAPTURE_STATUS_FILTERS,
  PAYMENT_METHODS_FILTERS,
  ORDER_AMOUNT_FILTER,
  ALL,
  BATCH_CAPTURE,
  PAYMENTS_INTEGRATION_TYPE_ITEMS,
  PAYMENT_OFFER_APPLIED_ITEMS,
} from './constants';

export default {
  [ALL]: {
    TABLE_COLUMNS: [
      {
        key: 'transactionTime',
        displayName: 'Date & Time',
        tooltip: {
          message: 'Transaction Added On',
        },
      },
      {
        key: 'orderId',
        displayName: 'Order ID',
      },
      {
        key: 'agentName',
        displayName: 'Agent Name',
      },
      {
        key: 'orderAmount',
        displayName: 'Order Amt.',
        align: 'right',
      },
      {
        key: 'refId',
        displayName: 'Transaction ID',
        tooltip: {
          message: 'Transaction ID',
        },
      },
      {
        key: 'customerReferenceId',
        displayName: 'Customer Ref ID',
        tooltip: {
          message: 'Customer Ref ID',
        },
      },
      {
        key: 'transactionAmount',
        displayName: 'Transaction Amt.',
        align: 'right',
        tooltip: {
          message: 'Transaction Amount',
        },
      },
      {
        key: 'customerPhone',
        displayName: 'Phone No.',
      },
      {
        key: 'cfCustomersPhone',
        displayName: `Customer's Phone No.`,
      },
      {
        key: 'pgUsed',
        displayName: 'PG',
      },
      {
        key: 'gatewayRefId',
        displayName: 'Gateway Ref Name',
        tooltip: {
          message: 'Gateway Ref Name',
        },
      },
      {
        key: 'paymentMode',
        displayName: 'Payment Method',
        tooltip: {
          message: 'Payment Method',
        },
      },
      {
        key: 'txStatus',
        displayName: 'Status',
      },
      {
        key: 'settlementStatus',
        displayName: 'Settlement Status',
      },
      {
        key: 'txRemarks',
        displayName: '',
        align: 'left',
      },
      {
        key: 'refundCta',
        displayName: '',
        pin: 'right',
      },
    ],
    FILTER_ITEMS: {
      txStatus: {
        displayText: 'Status',
        type: CHECKBOX,
        items: PAYMENT_STATUS_ITEMS,
      },
      isCaptured: CAPTURE_STATUS_FILTERS,
      paymentMode: PAYMENT_METHODS_FILTERS,
      orderAmount: ORDER_AMOUNT_FILTER,
      // paymentSource: PAYMENTS_INTEGRATION_TYPE_ITEMS,
      // isOfferApplied: PAYMENT_OFFER_APPLIED_ITEMS,
    },
    SEARCH_ITEMS: [
      {
        key: 'orderId',
        text: 'Order ID',
        value: 'orderId',
        placeholder: 'Ex: Order ID 1, Order ID 2',
        inputPattern: '^[\\|\\w\\d ,.-]+$',
        error:
          'Only alphanumeric and special characters (space, comma, dot, hyphen) are allowed.',
      },
      {
        key: 'transactionId',
        text: 'Transaction ID',
        value: 'transactionId',
        placeholder: 'Ex: Transaction ID 1, Transaction ID 2',
        inputPattern: '^[0-9,]+$',
        error: 'Only numbers and comma are allowed.',
      },
      {
        key: 'customerReferenceId',
        text: 'Customer Ref ID',
        value: 'customerReferenceId',
        placeholder: 'Enter Customer Ref ID',
        inputPattern: '^[a-zA-Z0-9_-]+$',
        error:
          'Only alphanumeric and special characters (underscore, hyphen) are allowed.',
      },
      {
        key: 'phoneNumber',
        text: 'Phone Number',
        value: 'customerPhone',
        placeholder: 'Enter Phone Number',
        inputPattern: '^[0-9 +-]+$',
        maxLength: 14,
        error:
          'Only numbers and special characters (space, plus, hyphen) are allowed.',
      },
      {
        key: 'cfCustomersPhone',
        text: `Customer's Phone No.`,
        value: 'cfCustomersPhone',
        placeholder: 'Enter Phone Number',
        inputPattern: '^[0-9 +-]+$',
        maxLength: 14,
        error:
          'Only numbers and special characters (space, plus, hyphen) are allowed.',
      },
      {
        key: 'email',
        text: 'Email ID',
        value: 'customerEmail',
        placeholder: 'Enter Email ID',
      },
      {
        key: 'rrn',
        text: 'Bank Reference No',
        value: 'rrn',
        placeholder: 'Enter Bank Reference No',
      },
    ],
  },
  [BATCH_CAPTURE]: {
    TABLE_COLUMNS: [
      {
        // key: 'txTime',
        key: 'createdAt',
        displayName: 'Uploaded At',
        width: 0.08,
        tooltip: {
          message: 'Batch File Added On',
        },
      },
      {
        key: '_id',
        displayName: 'Batch ID',
        width: 0.11,
      },
      {
        key: 'merchantFileName',
        displayName: 'File Name',
        width: 0.1,
      },
      {
        key: 'fileType',
        displayName: 'Type',
        width: 0.04,
      },
      {
        key: 'countSuccessful',
        displayName: 'Records Processed',
        width: 0.07,
      },
      {
        key: 'countTotal',
        displayName: 'Records Uploaded',
        width: 0.07,
      },
      {
        key: 'fileStatus',
        displayName: 'Status',
        width: 0.06,
      },
      {
        key: 'batchCaptureCta',
        displayName: '',
        width: 0.03,
      },
    ],
    SEARCH_ITEMS: [
      {
        key: 'batchFileId',
        text: 'Batch ID',
        value: 'fileId',
        placeholder: 'Enter Batch ID',
        inputPattern: '^[a-zA-Z0-9_-]+$',
        error:
          'Only alphanumeric and special characters (underscore, hyphen) are allowed.',
      },
      {
        key: 'fileName',
        text: 'File Name',
        value: 'merchantFileName',
        placeholder: 'Enter File Name',
      },
    ],
  },
};
